import { isMobile } from '../helpers/isMobile';
import { gameIds, gameNames } from './enumsByGames';

export const AnimationConfigs = {
  intro: 'back.in(1.5)',
  loop: 'linear',
  forceStop: 'back.out(2)',
  stopNormal: 'customStopNormal',
  stopFast: 'customStopFast',
  stopTurbo: 'customStopTurbo',
  START_SPEED: -3,
  STOPPING_STEPS: 5,
  REVERSE_STEPS_FAST_MODE: 10,
  REVERSE_STEPS_STANDARD_MODE: isMobile() ? 7 : 10,
};

export const gameGlobalStates = {
  none: 'none',
  show: 'show',
  waiting: 'waiting',
  bonus: 'bonus',
};

export const symbolSizesByGame = {
  [gameIds[gameNames.dazzlingFire5]]: {
    height: isMobile() ? 102 : 200,
    width: isMobile() ? 102 : 200,
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    height: isMobile() ? 102 : 200,
    width: isMobile() ? 102 : 200,
  },
}

export const reelsContainerParamsByGame = {
  [gameIds[gameNames.dazzlingFire5]]: {
    width: isMobile() ? 534 : 1040,
    height: isMobile() ? 306 : 600,
    xInFigma: isMobile() ? 3 : 200,
    yInFigma: isMobile() ? 256 : 105,
    offsetForContainerBoardWidth: isMobile() ? 1 : 3,
    offsetForContainerBoardHeight: isMobile() ? 1 : 3,
    spacing: isMobile() ? 6 : 10,
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    width: isMobile() ? 534 : 1040,
    height: isMobile() ? 306 : 600,
    xInFigma: isMobile() ? 3 : 200,
    yInFigma: isMobile() ? 256 : 105,
    offsetForContainerBoardWidth: isMobile() ? 1 : 3,
    offsetForContainerBoardHeight: isMobile() ? 1 : 3,
    spacing: isMobile() ? 6 : 10,
  },
}

export const reelParamsByGame = {
  [gameIds[gameNames.dazzlingFire5]]: {
    reelParams: {
      visibleRows: 3,
      iconsInReel: 9,
      iconsHeight: isMobile() ? 102 : 200,
      iconsWidth: isMobile() ? 102 : 200,
      finalPositionX: 0,
      finalPositionY: 0,
      iconsSpacing: 0,
      spacing: isMobile() ? 6 : 10,
      iconMargins: { default: 98 },
      offsetForContainerBoardWidth: isMobile() ? 0 : 0,
      speedDuration: 0.35,
      iconsFinalPositions: {
        inWinContainer: [],
        inReel: [],
      },
    },
    reelsCount: 5
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    reelParams: {
      visibleRows: 3,
      iconsInReel: 9,
      iconsHeight: isMobile() ? 102 : 200,
      iconsWidth: isMobile() ? 102 : 200,
      finalPositionX: 0,
      finalPositionY: 0,
      iconsSpacing: 0,
      spacing: isMobile() ? 6 : 10,
      iconMargins: { default: 98 },
      offsetForContainerBoardWidth: isMobile() ? 0 : 0,
      speedDuration: 0.35,
      iconsFinalPositions: {
        inWinContainer: [],
        inReel: [],
      },
    },
    reelsCount: 5
  },
}

